module.exports = __webpack_public_path__ + "img/test.4b5fa318.png";